export interface Translations {
  title: string;
  description1: string;
  description2: string;
  numberPlaceholder: string;
  chatButton: string;
  webButton: string;
  errorInvalidNumber: string;
  sendWhatsApp: string;
}

export const translations: Record<string, Translations> = {
  en: {
    title: 'Send WhatsApp message without saving contact',
    description1: 'Chat on WhatsApp without adding contacts.',
    description2: 'Enter phone number:',
    numberPlaceholder: 'Number goes here',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Does not look like a phone number',
    sendWhatsApp: 'Send WhatsApp'
  },
  es: {
    title: 'Enviar mensaje de WhatsApp sin guardar contacto',
    description1: 'Chatea en WhatsApp sin guardar contactos.',
    description2: 'Introduce el número de teléfono:',
    numberPlaceholder: 'Número aquí',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 No parece un número de teléfono válido',
    sendWhatsApp: 'Enviar WhatsApp'
  },
  pt: {
    title: 'Enviar mensagem do WhatsApp sem salvar contato',
    description1: 'Converse no WhatsApp sem adicionar contatos.',
    description2: 'Digite o número de telefone:',
    numberPlaceholder: 'Número aqui',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Não parece um número de telefone válido',
    sendWhatsApp: 'Enviar WhatsApp'
  },
  de: {
    title: 'WhatsApp-Nachricht senden ohne Kontakt zu speichern',
    description1: 'Chatte auf WhatsApp ohne Kontakte hinzuzufügen.',
    description2: 'Telefonnummer eingeben:',
    numberPlaceholder: 'Nummer hier eingeben',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Sieht nicht wie eine Telefonnummer aus',
    sendWhatsApp: 'WhatsApp senden'
  },
  fr: {
    title: 'Envoyer un message WhatsApp sans enregistrer le contact',
    description1: 'Discutez sur WhatsApp sans ajouter de contacts.',
    description2: 'Entrez le numéro de téléphone:',
    numberPlaceholder: 'Numéro ici',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Ne ressemble pas à un numéro de téléphone',
    sendWhatsApp: 'Envoyer WhatsApp'
  },
  ja: {
    title: '連絡先を保存せずにWhatsAppメッセージを送信',
    description1: '連絡先を追加せずにWhatsAppでチャット。',
    description2: '電話番号を入力してください：',
    numberPlaceholder: '番号をここに入力',
    chatButton: 'WhatsApp',
    webButton: 'ウェブ',
    errorInvalidNumber: '👆 電話番号ではないようです',
    sendWhatsApp: 'WhatsAppを送信'
  },
  uk: {
    title: 'Надіслати повідомлення WhatsApp без збереження контакту',
    description1: 'Спілкуйтеся в WhatsApp без додавання контактів.',
    description2: 'Введіть номер телефону:',
    numberPlaceholder: 'Номер тут',
    chatButton: 'WhatsApp',
    webButton: 'Веб',
    errorInvalidNumber: '👆 Не схоже на номер телефону',
    sendWhatsApp: 'Надіслати WhatsApp'
  },
  ru: {
    title: 'Отправить сообщение WhatsApp без сохранения контакта',
    description1: 'Общайтесь в WhatsApp без добавления контактов.',
    description2: 'Введите номер телефона:',
    numberPlaceholder: 'Номер телефона',
    chatButton: 'WhatsApp',
    webButton: 'Веб',
    errorInvalidNumber: '👆 Не похоже на номер телефона',
    sendWhatsApp: 'Отправить WhatsApp'
  },
  pl: {
    title: 'Wyślij wiadomość WhatsApp bez zapisywania kontaktu',
    description1: 'Rozmawiaj na WhatsApp bez dodawania kontaktów.',
    description2: 'Wprowadź numer telefonu:',
    numberPlaceholder: 'Wpisz numer tutaj',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Nie wygląda na numer telefonu',
    sendWhatsApp: 'Wyślij WhatsApp'
  },
  sr: {
    title: 'Пошаљи WhatsApp поруку без чувања контакта',
    description1: 'Ћаскајте на WhatsApp-у без додавања контаката.',
    description2: 'Унесите број телефона:',
    numberPlaceholder: 'Унесите број овде',
    chatButton: 'WhatsApp',
    webButton: 'Веб',
    errorInvalidNumber: '👆 Не изгледа као број телефона',
    sendWhatsApp: 'Пошаљи WhatsApp'
  },
  it: {
    title: 'Invia messaggio WhatsApp senza salvare il contatto',
    description1: 'Chatta su WhatsApp senza aggiungere contatti.',
    description2: 'Inserisci il numero di telefono:',
    numberPlaceholder: 'Inserisci il numero qui',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Non sembra un numero di telefono',
    sendWhatsApp: 'Invia WhatsApp'
  },
  tr: {
    title: 'Kişiyi kaydetmeden WhatsApp mesajı gönder',
    description1: 'Kişileri eklemeden WhatsApp\'ta sohbet edin.',
    description2: 'Telefon numarasını girin:',
    numberPlaceholder: 'Numarayı buraya girin',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Telefon numarasına benzemiyor',
    sendWhatsApp: 'WhatsApp Gönder'
  },
  hi: {
    title: 'संपर्क सहेजे बिना WhatsApp संदेश भेजें',
    description1: 'संपर्क जोड़े बिना WhatsApp पर चैट करें।',
    description2: 'फोन नंबर दर्ज करें:',
    numberPlaceholder: 'नंबर यहां दर्ज करें',
    chatButton: 'WhatsApp',
    webButton: 'वेब',
    errorInvalidNumber: '👆 फोन नंबर जैसा नहीं लगता',
    sendWhatsApp: 'WhatsApp भेजें'
  },
  ro: {
    title: 'Trimite mesaj WhatsApp fără a salva contactul',
    description1: 'Conversați pe WhatsApp fără a adăuga contacte.',
    description2: 'Introduceți numărul de telefon:',
    numberPlaceholder: 'Introduceți numărul aici',
    chatButton: 'WhatsApp',
    webButton: 'Web',
    errorInvalidNumber: '👆 Nu pare a fi un număr de telefon',
    sendWhatsApp: 'Trimite WhatsApp'
  }
};

export class I18n {
  private static currentLanguage: string = 'en';
  private static languageSelector: HTMLSelectElement | null = null;

  static initialize(): void {
    // Detect browser language
    const browserLang = navigator.language.split('-')[0];
    this.currentLanguage = this.isLanguageSupported(browserLang) ? browserLang : 'en';
    
    // Create language selector
    this.createLanguageSelector();
    
    // Apply translations
    this.applyTranslations();
  }

  static isLanguageSupported(lang: string): boolean {
    return Object.keys(translations).indexOf(lang) !== -1;
  }

  static createLanguageSelector(): void {
    // Create language selector element
    const selector = document.createElement('select');
    selector.id = 'language-selector';
    selector.className = 'language-selector';
    
    // Add options for each language
    Object.keys(translations).forEach(lang => {
      const option = document.createElement('option');
      option.value = lang;
      option.textContent = lang.toUpperCase();
      option.selected = lang === this.currentLanguage;
      selector.appendChild(option);
    });
    
    // Add event listener
    selector.addEventListener('change', (e) => {
      const target = e.target as HTMLSelectElement;
      this.currentLanguage = target.value;
      this.applyTranslations();
    });
    
    // Add to DOM
    const main = document.querySelector('body');
    if (main) {
      const langContainer = document.createElement('div');
      langContainer.className = 'language-container';
      langContainer.appendChild(selector);
      main.appendChild(langContainer);
    }
    
    this.languageSelector = selector;
  }

  static applyTranslations(): void {
    const t = translations[this.currentLanguage];
    
    // Update document title
    document.title = t.title;
    
    // Update HTML lang attribute
    document.documentElement.lang = this.currentLanguage;
    
    // Update h2 title
    const titleElement = document.querySelector('h2');
    if (titleElement) {
      // Preserve the icon
      const icon = titleElement.querySelector('i');
      titleElement.innerHTML = '';
      if (icon) titleElement.appendChild(icon);
      titleElement.appendChild(document.createTextNode(t.sendWhatsApp));
    }
    
    // Update description
    const descriptionElement = document.querySelector('.description');
    if (descriptionElement) {
      descriptionElement.innerHTML = `${t.description1}<br/>${t.description2}`;
    }
    
    // Update input placeholder
    const inputElement = document.getElementById('number') as HTMLInputElement;
    if (inputElement) {
      inputElement.placeholder = t.numberPlaceholder;
    }
    
    // Update buttons
    const chatButton = document.getElementById('send_app');
    if (chatButton) {
      // Preserve the icon
      const icon = chatButton.querySelector('i');
      chatButton.innerHTML = '';
      if (icon) chatButton.appendChild(icon);
      chatButton.appendChild(document.createTextNode(t.chatButton));
    }
    
    const webButton = document.getElementById('send_web');
    if (webButton) {
      // Preserve the icon
      const icon = webButton.querySelector('i');
      webButton.innerHTML = '';
      if (icon) webButton.appendChild(icon);
      webButton.appendChild(document.createTextNode(t.webButton));
    }
  }

  static getCurrentTranslation(): Translations {
    return translations[this.currentLanguage];
  }
} 